import Swiper from 'swiper/bundle';

export default () => {
  const slider = document.querySelectorAll('.js-archive-section-swiper');
  const breakpoint = window.matchMedia( '(min-width:1023px)' )
  let mySwipers = [];

  breakpoint.addEventListener('change', initArchiveSliders);
  initArchiveSliders();

  function initArchiveSliders() {
    if ( breakpoint.matches === true ) {
      mySwipers.forEach(swiper => {
        if (swiper !== undefined) {
          swiper.destroy( true, true )
        }
      });
    } else if ( breakpoint.matches === false ) {
      slider.forEach(element => {
         enableSwiper(element);
      });
    }
  }

  function enableSwiper (el) {
    let slides_count = el.querySelectorAll('.js-filter-product').length;
    if (slides_count > 1) {      
      let newSwiper = new Swiper(el, {
        slidesPerView: 1,
        centeredSlides: true,
      });
  
      mySwipers.push(newSwiper)
    }
  }
}